import { PREFILTERED_JOB_SEARCH_ENABLED_LOCALES } from "@/modules/jobSearchPrefiltered/constants"
import { cleanNextDataUrlOrPathname } from "@/modules/routing/cleanNextDataUrlOrPathname"
import { isNextDataUrlOrPathname } from "@/modules/routing/isNextDataUrlOrPathname"

export const isPrefilteredJobSearchListUrlOrPathname = (url: string): boolean => {
  let { pathname } = new URL(url, "http://localhost")

  if (isNextDataUrlOrPathname(pathname)) {
    pathname = cleanNextDataUrlOrPathname(pathname)
  }

  return PREFILTERED_JOB_SEARCH_ENABLED_LOCALES.some(locale =>
    new RegExp(`^/${locale}/job-search/list$`).test(pathname)
  )
}
